import { useEffect, useMemo } from 'react';

import { useGetPermissions, isNewUser } from '~platform/auth';
import { useMerchantsListQuery } from '~platform/entities/merchant';

import {
  CHAT_SEGMENTS,
  ChatSegment,
  FEATURE_FLAG_ATTRIBUTES,
  growthBookInstance,
} from '~shared/growthbook';

export function useSyncChatSegment() {
  const { data: permissions } = useGetPermissions();
  const isNotNewUser = permissions !== undefined && !isNewUser(permissions);

  const { data: merchants } = useMerchantsListQuery({
    enabled: isNotNewUser,
  });

  const chatSegment: ChatSegment | null = useMemo(() => {
    if (!permissions) {
      return null;
    }

    if (isNewUser(permissions)) {
      return CHAT_SEGMENTS.NEW_USER;
    }

    if (!merchants) {
      return null;
    }

    return merchants.length > 0 && merchants.every((m) => m.segment === 'SME')
      ? CHAT_SEGMENTS.SME
      : CHAT_SEGMENTS.KA_OR_MIXED;
  }, [permissions, merchants]);

  useEffect(() => {
    if (chatSegment) {
      growthBookInstance.updateAttributes({
        [FEATURE_FLAG_ATTRIBUTES.CHAT_SEGMENT]: chatSegment,
      });
    }
  }, [chatSegment]);
}
